// In-memory store for the marketplace JWT.
//
// In embedded Shopify Admin (iframe), the FE origin is third-party relative to
// admin.shopify.com. Chrome incognito and Safari block third-party cookies, so
// `Cookies.set("authToken", ...)` is silently dropped — the next request goes
// out without X-Marketplace-Token and the backend can't identify the company.
// Holding the token in module scope survives until the iframe reloads, which
// is enough for the merchant to sign in and link their store in one session.

let marketplaceToken: string | null = null;

export function setMarketplaceToken(token: string | null): void {
  marketplaceToken = token;
}

export function getMarketplaceToken(): string | null {
  return marketplaceToken;
}
